import { useTranslation } from 'react-i18next'
import { StyleSheet, ViewProps } from 'react-native'
import { ProductsFilter, useProducts } from 'zens-store'
import { PageHeaderProps, TablePagination, TableSort } from 'zens-storybook'

import { LayoutHeader } from '../layout'

const styles = StyleSheet.create({
  container: {},
})

interface Props extends PageHeaderProps {
  companyId: number
  pagination?: TablePagination
  sort?: TableSort
  filter?: ProductsFilter
}

const ProductListHeader = (props: Props) => {
  const { companyId, pagination, sort, filter, style, ...otherProps } = props
  const { t } = useTranslation()

  const products = useProducts({ companyId, pagination, sort, filter }, { enabled: !!filter })
  return (
    <LayoutHeader
      style={[styles.container, style]}
      title={t('Devices')}
      titleRight={products.data?.meta?.total ? ` (${products.data?.meta?.total})` : ''}
      {...otherProps}
    />
  )
}

interface SkeletonProps extends ViewProps {}
const Skeleton = (props: SkeletonProps) => {
  const { style, ...otherProps } = props
  return <LayoutHeader.Skeleton style={[styles.container, style]} breadcrumb title {...otherProps} />
}
ProductListHeader.Skeleton = Skeleton
export default ProductListHeader
